var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cont",staticClass:"cont"},[_c('GrcDB',{ref:"GRCDB"}),_c('GrcFilePasswordInput',{ref:"FilePasswordInput"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }